import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './tabs.module.scss';
import { getPastInsuranceRequest } from '../../../../../store/actions/patients';
import Loader from '../../../../_common/Loader/Loader';
import Modal from '../../../../_common/Modal/Modal';
import InsuranceModalContent from './InsuranceModalContent/InsuranceModalContent';
import accountHelpers from '../../../../../utils/accountHelpers';

const viewData = [
  {
    name: 'Plan',
    path: 'plan',
  },
  {
    name: 'BIN',
    path: 'BIN',
  },
  {
    name: 'Group',
    path: 'insGroup',
  },
  {
    name: 'ID',
    path: 'insID',
  },
  {
    name: 'PCN',
    path: 'PCN',
  },
  {
    name: 'Type',
    path: 'insType',
  },
];

function MedicalInsurance() {
  const dispatch = useDispatch();
  const { patient } = useSelector((store) => store.patients);

  // const { patientId } = useParams();
  const [loading, setLoading] = useState(false);
  const [isInsuranceModalOpen, insuranceModalToggle] = useState(false);

  // useEffect(() => {
  //   (async () => {
  //     setLoading(true);
  //     await dispatch(getPastInsuranceRequest({ patientId })); //<==delete action
  //   })();
  //   setLoading(false);
  // }, []);

  return (
    <div className={classes.wrapper}>
      {loading ? <Loader /> : (
        <div className={classes.viewData}>
          <div>
            <h2>Primary Insurance</h2>

            <div>
              <ul className={classes.titles}>
                {viewData.map((v) => (
                  <li key={v.name}>
                    <div className={classes.title}>
                      {v.name}
                    </div>

                    <div>
                      {patient?.Prim?.[v.path] || '-'}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <h2>Secondary Insurance</h2>

            <div>
              <ul className={classes.titles}>
                {viewData.map((v) => (
                  <li key={v.name}>
                    <div className={classes.title}>
                      {v.name}
                    </div>

                    <div>
                      {patient?.Sec?.[v.path] || '-'}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}

      {accountHelpers.getUser().role !== 'Patient' && (
      <div className={classes.button_wrapper}>
        <Button
          className={classes.button}
          title="Edit insurance"
          type="button"
          editButton
          onClick={() => insuranceModalToggle(true)}
        />
      </div>
      )}

      <Modal
        open={isInsuranceModalOpen}
        onClose={() => insuranceModalToggle(false)}
        className={classes.insurance_modal}
      >
        <InsuranceModalContent
          onCancel={() => insuranceModalToggle(false)}
        />
      </Modal>
    </div>
  );
}

export default MedicalInsurance;
